/**
 * Copyright 2017 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import { LOGOUT_USER } from "openstack-uicore-foundation/lib/security/actions";
import { DEFAULT_PER_PAGE } from "../utils/constants";
import {
  ACCESS_REQUEST_ADDED,
  RECEIVE_REQUESTS,
  REQUEST_DELETED
} from "../actions/show-actions";

const DEFAULT_STATE = {
  requests: [],
  currentPage: 1,
  lastPage: 1,
  perPage: DEFAULT_PER_PAGE,
  total: 0
};

const requestListReducer = (state = DEFAULT_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT_USER:
      return DEFAULT_STATE;
    case REQUEST_DELETED: {
      const { requestId } = payload;
      return {
        ...state,
        requests: state.requests.filter((r) => r.id !== requestId),
        total: state.total - 1
      };
    }
    case RECEIVE_REQUESTS: {
      const {
        data,
        total,
        last_page: lastPage,
        per_page: perPage,
        current_page: currentPage
      } = payload.response;

      const requests = data.map((it) => ({
        id: it.id,
        sponsor: it.company_name,
        summit_id: it.summit_id,
        summit: it.summit
      }));

      return {
        ...state,
        requests,
        total,
        lastPage,
        perPage,
        currentPage
      };
    }
    case ACCESS_REQUEST_ADDED: {
      const { response } = payload;
      const newRequest = {
        id: response.id,
        summit: response.summit,
        sponsor: response.company_name
      };

      return {
        ...state,
        requests: [newRequest, ...state.requests],
        total: state.total + 1
      };
    }
    default:
      return state;
  }
};

export default requestListReducer;
